<div class="survey-container contentcontainer codecontainer">
    <div [id]="getId()"></div>
</div>

<app-mazars-display-dialog #moreInfoDisplayDialog [uid]="'survey-dialog'" [okBtnText]="l('Cancel')" [title]="l('Information')">
    <div id="questionDescriptionText"></div>
</app-mazars-display-dialog>
